import { Alert, AlertDescription, AlertTitle } from '#/components/ui/alert';
import React from 'react';
import { Await, Link } from 'react-router';
import { twMerge } from 'tailwind-merge';

import type { SurfaceNewsResponseV1 } from '~/api/v1/mall/surface-news';
import { DATA_AREAS } from '~/constants/data-areas';
import { AwaitErrorElement } from '~/ui/await-error-element';
import { formatDate } from '~/utils';

import { dateFormats } from '../config';
import { SvgIconArrowRight } from '../svg/icon-arrow-right';
import { SvgIconInformation } from '../svg/icon-information';

export const SiteImportantNewsList = ({
  importantNewsPromise,
}: {
  importantNewsPromise: Promise<SurfaceNewsResponseV1>;
}) => {
  return (
    <>
      {importantNewsPromise && (
        <React.Suspense fallback={null}>
          <Await
            resolve={importantNewsPromise}
            errorElement={<AwaitErrorElement message="importantNews Promise failed" />}>
            {(importantNews) =>
              importantNews.information &&
              importantNews.information.length > 0 && (
                <div className="mb-6 grid w-full" data-area={DATA_AREAS.SITE_IMPORTANT_NEWS_LIST}>
                  {importantNews.information.map((news) => {
                    let link: string | undefined = undefined;
                    if (news.link_type === 2) {
                      link = `/${news.campaign_type === 1 ? 'shop' : 'offer'}/${news.campaign_id}`;
                    } else if (news.link_type === 3) {
                      link = `/event/${news.event_id}`;
                    } else if (news.link_type === 4) {
                      link = news.external_url || '/';
                    }

                    return (
                      <Alert
                        key={news.date + news.title}
                        className={twMerge(
                          'mb-2 grid gap-x-3 rounded-sm border-1 border-blue-200 bg-blue-50 p-4 *:text-blue-700',
                          link && 'has-[>svg]:grid-cols-[auto_1fr_auto] has-[>svg]:gap-x-2'
                        )}>
                        <SvgIconInformation aria-label="Information" width={24} height={24} className="self-start" />
                        <div>
                          <p className="text-caption-m mt-1">{formatDate(news.date, dateFormats.yearMonthDay)}</p>
                          {link ? (
                            <AlertTitle className="text-body-s-bold mb-2">
                              <Link to={link} aria-label={news.title}>
                                {news.title}
                              </Link>
                            </AlertTitle>
                          ) : (
                            <AlertTitle className="text-body-s-bold mb-2">{news.title}</AlertTitle>
                          )}
                          {news.text && <AlertDescription className="text-body-s">{news.text}</AlertDescription>}
                        </div>
                        {link && (
                          <SvgIconArrowRight aria-label="arrow-right" width={17} height={17} className="self-center" />
                        )}
                      </Alert>
                    );
                  })}
                </div>
              )
            }
          </Await>
        </React.Suspense>
      )}
    </>
  );
};
